/**
 * Remplace le tooltip Shopify Inbox et force l’alignement bas-gauche
 * (opposé au gift bas-droite) — sans boucle MutationObserver.
 */
(function () {
  'use strict';

  var LABEL = 'Discuter avec ENFAMI';
  var SELECTORS = [
    '#shopify-chat',
    'shopify-chat',
    '#ShopifyChat',
    'iframe#ShopifyChat',
    'iframe#dummy-chat-button-iframe',
    'iframe[id*="ShopifyChat" i]',
    'iframe[title*="Shopify" i]',
    'iframe[title*="chat" i]',
    'iframe[title*="boutique" i]'
  ];
  var applied = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var mo = null;
  var timer = null;
  var debounceTimer = null;

  function needsLabel(el) {
    if (!el || el.nodeType !== 1) return false;
    var t = (el.getAttribute('title') || el.title || '').trim();
    var a = (el.getAttribute('aria-label') || '').trim();
    if (t === LABEL && (a === LABEL || a === '')) return false;
    if (!t && !a) return true;
    var blob = (t + ' ' + a).toLowerCase();
    return (
      blob.indexOf('shopify') !== -1 ||
      blob.indexOf('boutique en ligne') !== -1 ||
      blob.indexOf('online store') !== -1 ||
      blob === 'chat' ||
      blob.indexOf('chat with') !== -1
    );
  }

  function pinLeft(el) {
    if (!el || el.nodeType !== 1) return;
    try {
      el.classList.add('ef-chat-left');
      el.style.setProperty('left', 'var(--ef-float-edge, 16px)', 'important');
      el.style.setProperty('right', 'auto', 'important');
      el.style.setProperty('transform', 'none', 'important');
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'absolute') {
        el.style.setProperty('position', pos, 'important');
      }
    } catch (e) { /* noop */ }
  }

  function apply(el) {
    if (!el || el.nodeType !== 1) return false;
    if (applied && applied.has(el) && !needsLabel(el)) {
      pinLeft(el);
      return true;
    }
    try {
      if (needsLabel(el)) {
        el.setAttribute('title', LABEL);
        el.setAttribute('aria-label', LABEL);
        if ('title' in el) el.title = LABEL;
      }
      pinLeft(el);
      if (applied) applied.add(el);
      return true;
    } catch (e) {
      return false;
    }
  }

  function scan() {
    var found = false;
    SELECTORS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (apply(el)) found = true;
          var p = el.parentElement;
          if (p && p !== document.body && p !== document.documentElement) {
            var cs = window.getComputedStyle(p);
            if (cs.position === 'fixed' || cs.position === 'absolute') pinLeft(p);
          }
        });
      } catch (e) { /* selector unsupported */ }
    });
    return found;
  }

  function scheduleScan() {
    if (debounceTimer) return;
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      if (scan() && mo) {
        try { mo.disconnect(); } catch (e) {}
        mo = null;
      }
    }, 250);
  }

  function start() {
    scan();
    var tries = 0;
    timer = setInterval(function () {
      tries += 1;
      if (scan() || tries >= 24) {
        clearInterval(timer);
        timer = null;
        if (mo) {
          try { mo.disconnect(); } catch (e) {}
          mo = null;
        }
      }
    }, 750);

    if (typeof MutationObserver === 'undefined') return;
    mo = new MutationObserver(function (mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
          relevant = true;
          break;
        }
      }
      if (relevant) scheduleScan();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
